export const DEFAULT_PARAMS = {
  volume: 0.85,
  sag: 0.3,
  lowerWidth: 0.5,
  nipplePlateau: 0.2,
  nippleSize: 0.5,
  areolRadius: 0.5,
  skinTone: 0.25,
  roughness: 0.45,
  sssStrength: 0.6,
  veins: 0.1,
};

export const PRESETS = {
  petite: {
    volume: 0.5, sag: 0.1, lowerWidth: 0.4,
    nipplePlateau: 0.2, nippleSize: 0.35, areolRadius: 0.3,
    skinTone: 0.15, roughness: 0.4, sssStrength: 0.75, veins: 0.05,
  },
  natural: {
    volume: 1.0, sag: 0.35, lowerWidth: 0.5,
    nipplePlateau: 0.2, nippleSize: 0.5, areolRadius: 0.5,
    skinTone: 0.25, roughness: 0.45, sssStrength: 0.65, veins: 0.1,
  },
  full: {
    volume: 1.4, sag: 0.5, lowerWidth: 0.6,
    nipplePlateau: 0.2, nippleSize: 0.6, areolRadius: 0.7,
    skinTone: 0.3, roughness: 0.5, sssStrength: 0.55, veins: 0.2,
  },
  athletic: {
    volume: 0.65, sag: 0.12, lowerWidth: 0.3,
    nipplePlateau: 0.2, nippleSize: 0.4, areolRadius: 0.38,
    skinTone: 0.45, roughness: 0.35, sssStrength: 0.7, veins: 0.18,
  },
  dark: {
    volume: 1.15, sag: 0.45, lowerWidth: 0.5,
    nipplePlateau: 0.2, nippleSize: 0.55, areolRadius: 0.75,
    skinTone: 0.82, roughness: 0.5, sssStrength: 0.35, veins: 0.05,
  },
};

const PARAM_RANGES = {
  volume:        { min: 0.3,  max: 2.5 },
  sag:           { min: 0,    max: 0.5 },
  lowerWidth:    { min: 0,    max: 1.0 },
  nipplePlateau: { min: 0.2,  max: 0.9 },
  nippleSize:    { min: 0.1,  max: 0.8 },
  areolRadius:   { min: 0.1,  max: 1.0 },
  skinTone:      { min: 0,    max: 1.0 },
  roughness:     { min: 0.1,  max: 0.9 },
  sssStrength:   { min: 0,    max: 1.0 },
  veins:         { min: 0,    max: 1.0 },
};

export function sanitizeParams(raw) {
  const result = { ...DEFAULT_PARAMS };
  for (const key of Object.keys(PARAM_RANGES)) {
    const range = PARAM_RANGES[key];
    const val = parseFloat(raw?.[key]);
    if (Number.isFinite(val)) {
      result[key] = Math.min(range.max, Math.max(range.min, val));
    }
  }
  return result;
}

export function randomPreset() {
  return {
    volume: 0.3 + Math.random() * 2.2,
    sag: Math.random() * 0.5,
    lowerWidth: Math.random(),
    nipplePlateau: 0.2 + Math.random() * 0.7,
    nippleSize: 0.1 + Math.random() * 0.7,
    areolRadius: 0.15 + Math.random() * 0.85,
    skinTone: Math.random(),
    roughness: 0.2 + Math.random() * 0.65,
    sssStrength: 0.3 + Math.random() * 0.7,
    veins: Math.random() * 0.5,
  };
}
